import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import * as style from "./cover.module.scss"

const Cover = ({ image, title, paragraph, button, buttonLink }) => {
  // const [scrollPos, setScrollPos] = useState(0)

  // useEffect(() => {
  //   window.addEventListener("scroll", () => {
  //     setScrollPos(window.pageYOffset / 4)
  //   })
  // })

  return (
    <section
      className={style.cover}
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: `cover`,
        backgroundPosition: `50% 50%`,
        backgroundRepeat: `no-repeat`,
      }}
    >
      <div className={`content-sm`}>
        <h1 className={`center`}>{title}</h1>
        <p className={`center`}>{paragraph}</p>
        {button && (
          <Link to={buttonLink}>
            <button>{button}</button>
          </Link>
        )}
      </div>
    </section>
  )
}

Cover.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  paragraph: PropTypes.string,
  button: PropTypes.string,
  buttonLink: PropTypes.string,
}

Cover.defaultProps = {
  image: ``,
  title: ``,
  paragraph: ``,
  buttonLink: ``,
}

export default Cover